export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7ce7ba786c76d9217ba69eed1a50eeb10cad582d&name=fetchTypeahead!'